<script setup>
import { useStore } from 'vuex'
import { computed } from 'vue'

const props = defineProps({
  username: {
    type: String,
    default: null
  },
  bg: {
    type: String,
    default: 'bg-gray-100 dark:bg-gray-700'
  },
  api: {
    type: String,
    default: 'api/avataaars'
  }
})

const store = useStore()

const avatar = computed(() => {
  const user = store.state.auth.user?.user
  const seed = (props.username || user?.name || 'anonymous').replace(/[^a-z0-9]+/i, '-')
  return user?.avatar || `https://api.dicebear.com/5.x/identicon/svg?seed=${seed}`
})

const name = computed(() => props.username ? props.username : store.state.userName)
</script>

<template>
  <div class="rounded-full overflow-hidden ring-1 ring-gray-200 dark:ring-gray-700">
    <img
      :src="avatar"
      :alt="name ? `${name} avatar` : 'User avatar'"
      loading="lazy"
      class="rounded-full block h-auto w-full max-w-full"
      :class="bg"
    >
  </div>
</template>
